import format from "date-fns/format";

import { monthAndYearFormat } from "@/constants/date";

export const formatDate = (date: string | Date | number | null) =>
    date ? format(new Date(date), monthAndYearFormat) : null;
